import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class InvalidEnrollmentApplication {
  public readonly key = 'InvalidEnrollmentApplication';

  constructor(
    public readonly file: File | undefined
  ) {}
}

export class ValidEnrollmentApplication {
  public readonly key = 'ValidEnrollmentApplication';

  private constructor(
    public readonly file: File
  ) {}

  public static create(
    file: File | undefined
  ): EnrollmentApplication {
    return file ? new ValidEnrollmentApplication(file)
      : new InvalidEnrollmentApplication(file);
  }
}

export class EnrollmentApplicationWithError {
  public readonly key = 'EnrollmentApplicationWithError';

  constructor(
    public readonly file: File
  ) {}
}

export class EnrollmentApplicationWithDuplicateUploadError {
  public readonly key = 'EnrollmentApplicationWithDuplicateUploadError';

  constructor(
    public readonly file: File
  ) {}
}

export class SavingEnrollmentApplication {
  public readonly key = 'SavingEnrollmentApplication';

  constructor(
    public readonly file: File
  ) {}
}

export type EnrollmentApplication =
  | ValidEnrollmentApplication
  | InvalidEnrollmentApplication
  | EnrollmentApplicationWithError
  | EnrollmentApplicationWithDuplicateUploadError
  | SavingEnrollmentApplication;

export type EnrollmentApplicationOptions<TReturn> = ToMatchOptions<EnrollmentApplication, 'key', TReturn>;

export const matchEnrollmentApplication = <TReturn>(
  enrollmentApplication: EnrollmentApplication,
  options: EnrollmentApplicationOptions<TReturn>
): TReturn => {
  switch (enrollmentApplication.key) {
    case 'EnrollmentApplicationWithError':
      return options.EnrollmentApplicationWithError(enrollmentApplication);
    case 'EnrollmentApplicationWithDuplicateUploadError':
      return options.EnrollmentApplicationWithDuplicateUploadError(enrollmentApplication);
    case 'InvalidEnrollmentApplication':
      return options.InvalidEnrollmentApplication(enrollmentApplication);
    case 'ValidEnrollmentApplication':
      return options.ValidEnrollmentApplication(enrollmentApplication);
    case 'SavingEnrollmentApplication':
      return options.SavingEnrollmentApplication(enrollmentApplication);
  }
};

export const isValidApplication = (application: EnrollmentApplication): application is ValidEnrollmentApplication => {
  return application.key === 'ValidEnrollmentApplication';
}

export const EmptyEnrollmentApplication = new InvalidEnrollmentApplication(
  undefined
);
